// components/animations/LikeBurst.js
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

export const LikeBurst = () => {
  const [hearts, setHearts] = useState([])

  useEffect(() => {
    const h = Array.from({ length: 10 }, (_, i) => ({
      id: i,
      x: Math.random() * 100 - 50,
      y: -Math.random() * 100 - 20,
      scale: Math.random() * 0.5 + 0.8,
      delay: Math.random() * 0.3,
    }))
    setHearts(h)

    const timeout = setTimeout(() => setHearts([]), 800)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
      {hearts.map((heart) => (
        <motion.div
          key={heart.id}
          className="absolute text-red-500 text-sm"
          initial={{ x: 0, y: 0, opacity: 1, scale: 1 }}
          animate={{
            x: heart.x,
            y: heart.y,
            opacity: 0,
            scale: heart.scale,
          }}
          transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: heart.delay,
          }}
        >
          ❤️
        </motion.div>
      ))}
    </div>
  )
}
